module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "localUser",
    attrs: {
      "label-position": "left",
      "label-width": "150px",
      "model": _vm.localUser,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.localUser.email),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "email", $$v)
      },
      expression: "localUser.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "first_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Name"
    },
    model: {
      value: (_vm.localUser.first_name),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "first_name", $$v)
      },
      expression: "localUser.first_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Surname",
      "prop": "last_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Surname"
    },
    model: {
      value: (_vm.localUser.last_name),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "last_name", $$v)
      },
      expression: "localUser.last_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Job Title",
      "prop": "job_title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Job Title"
    },
    model: {
      value: (_vm.localUser.job_title),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "job_title", $$v)
      },
      expression: "localUser.job_title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Groups",
      "prop": "groups"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Select Groups",
      "disabled": !this.loggedInUser.is_admin
    },
    model: {
      value: (_vm.localUser.groups),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "groups", $$v)
      },
      expression: "localUser.groups"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tags",
      "prop": "tags"
    }
  }, [_vm._l((_vm.localUser.tags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleCloseTag(tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
  }), _vm._v(" "), (_vm.tagInputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.tagInputValue),
      callback: function($$v) {
        _vm.tagInputValue = $$v
      },
      expression: "tagInputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleShowTagInput
    }
  }, [_vm._v("\n        + New Tag\n      ")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Company Admin",
      "prop": "is_admin"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No",
      "disabled": !this.loggedInUser.is_admin
    },
    model: {
      value: (_vm.localUser.is_admin),
      callback: function($$v) {
        _vm.$set(_vm.localUser, "is_admin", $$v)
      },
      expression: "localUser.is_admin"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "id": "cancel",
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "save",
      "type": "primary",
      "loading": _vm.savingUser,
      "plain": ""
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [_vm._v("Save")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-209131c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/user/UserManage.vue
// module id = 3177
// module chunks = 3